// src/services/welcomeMoment.js
//
// A one-shot marker saying "this session just came back from checkout".
//
// Set on EITHER entry door (/workouts?subscribed=true or /class/:id?subscribed=true)
// and read by Workouts, which owns the single render site for the welcome modal.
// Session-scoped with a TTL because it describes one journey through checkout,
// not a lasting fact about the member.
//
// Deliberately touches no Firestore: the welcome asks nothing and records
// nothing, so showing it costs zero reads and zero writes. (An earlier revision
// carried an attribution question here and needed a lookup; the owner chose a
// warm note over a question — see docs/decisions/adr-signup-attribution.md.)

const PENDING_KEY = 'mom_welcome_pending_at';
const PENDING_TTL_MS = 30 * 60 * 1000;

// Storage access is wrapped because Safari private mode throws on write, and a
// welcome nicety must never take down the page a paying member just landed on.
function safeGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
}
function safeSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (_) { /* non-critical */ }
}
function safeRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (_) { /* non-critical */ }
}

export function markWelcomePending() {
    safeSet(PENDING_KEY, String(Date.now()));
}

export function hasWelcomePending() {
    const raw = safeGet(PENDING_KEY);
    if (!raw) return false;
    const at = Number(raw);
    if (!Number.isFinite(at)) return false;
    // An expired marker is a stale journey — clear it so it can't fire later.
    if (Date.now() - at > PENDING_TTL_MS) { clearWelcomePending(); return false; }
    return true;
}

export function clearWelcomePending() {
    safeRemove(PENDING_KEY);
}
